// import { Button } from "@/Button";
import {
  useCallback,
  // useRef,
  useState,
  useEffect,
} from "react";
import { TruckIcon } from "@/Icon/TruckIcon";
// import chevironLeft from "$/cheviron-left.svg";
// import chevironRight from "$/cheviron-right.svg";
import {
  useReservTypeList,
  ReservType,
} from "../../../api/services/business/calendar";
import ReservationTimeline from "./ReservationTimeline";
import { useBusinessReserveList } from "../../../api/services/business/reserve";
import { motion } from "framer-motion";
import defaultPet from "$/defaultLogo.svg";
import { useRouter } from "@tanstack/react-router";

/** 수업 외 예약의 시작/종료 시간 표기 (호텔은 날짜 포함 2줄) */
export function buildTimeLines(r: {
  cdReservType?: string;
  startDate?: string | null;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}): string[] {
  const t = (s?: string | null) => (s ? s.slice(0, 5) : "");
  const d = (s?: string | null) => (s ? `${s.slice(5, 7)}.${s.slice(8, 10)}` : "");
  if (!r.cdReservType || r.cdReservType === "RESERV_TYPE_CLASS") return [];
  if (r.cdReservType === "RESERV_TYPE_HOTEL") {
    // 시작일은 타임라인 날짜 헤더가 보여주므로 시작 시간 ~ 종료 날짜·시간만 표시
    return [`${t(r.startTime)} ~ ${d(r.endDate)} ${t(r.endTime)}`];
  }
  if (!r.startTime) return [];
  return [r.endTime ? `${t(r.startTime)} ~ ${t(r.endTime)}` : t(r.startTime)];
}

interface CalendarConfirmProps {
  sharedDate: {
    year: number;
    month: number;
    day: number;
  };
  setSharedDate: React.Dispatch<
    React.SetStateAction<{
      year: number;
      month: number;
      day: number;
    }>
  >;
  clickModal: () => void;
}

// props(sharedDate / setSharedDate / clickModal)는 날짜 이동 UI 복원 시 사용한다.
// 현재는 날짜와 무관하게 전체를 조회하므로 사용하지 않는다.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CalendarConfirm = (_props: CalendarConfirmProps) => {
  const { history } = useRouter();
  // const direction = useRef<boolean>();
  // NOTE: 확정 예약 목록은 날짜와 무관하게 전체를 조회하므로
  // sharedDate 로 currentDate 를 계산하던 로직은 제거했다.
  // (날짜 이동 UI 를 복원할 경우 함께 되살릴 것)

  // 예약 타입 리스트 조회
  const { data: reservTypes = [], isLoading } = useReservTypeList();
  // 선택된 예약 타입 상태
  const [selectedReservType, setSelectedReservType] =
    useState<ReservType | null>(null);

  // 첫 번째 데이터를 기본 선택으로 설정
  useEffect(() => {
    if (reservTypes.length > 0 && !selectedReservType) {
      setSelectedReservType(reservTypes[0]);
    }
  }, [reservTypes, selectedReservType]);

  // const handlePrev = useCallback(
  //   (e: React.MouseEvent<HTMLButtonElement>) => {
  //     e.preventDefault();
  //     direction.current = false;
  //     const dateObj = new Date(
  //       currentDate.year,
  //       currentDate.month,
  //       currentDate.day
  //     );
  //     dateObj.setDate(dateObj.getDate() - 1);

  //     const newDate = {
  //       year: dateObj.getFullYear(),
  //       month: dateObj.getMonth(),
  //       day: dateObj.getDate(),
  //     };

  //     // 공유 날짜 상태 업데이트
  //     setSharedDate(newDate);
  //   },
  //   [currentDate, setSharedDate]
  // );

  // const handleNext = useCallback(
  //   (e: React.MouseEvent<HTMLButtonElement>) => {
  //     e.preventDefault();
  //     direction.current = true;
  //     const dateObj = new Date(
  //       currentDate.year,
  //       currentDate.month,
  //       currentDate.day
  //     );
  //     dateObj.setDate(dateObj.getDate() + 1);

  //     const newDate = {
  //       year: dateObj.getFullYear(),
  //       month: dateObj.getMonth(),
  //       day: dateObj.getDate(),
  //     };

  //     // 공유 날짜 상태 업데이트
  //     setSharedDate(newDate);
  //   },
  //   [currentDate, setSharedDate]
  // );

  // 확정 예약은 날짜와 무관하게 전체를 조회한다.
  // (서버 GET /api/business/reserve/list 는 날짜 파라미터를 받지 않는다)
  const {
    data: reserveList,
    isLoading: isReserveListLoading,
    isError: isReserveListError,
  } = useBusinessReserveList(
    "RESERV_STATUS_CONFIRMED", // cdReservStatus
    selectedReservType?.key || undefined, // cdReservType
    !!selectedReservType // enabled
  );

  // 예약 타입 선택 핸들러
  const handleReservTypeClick = useCallback((reservType: ReservType) => {
    setSelectedReservType(reservType);
  }, []);

  return (
    <>
      <div className="px-4 pt-2 bg-white">
        {/* <div className="flex gap-10 items-center m-auto w-fit">
          <Button onClick={handlePrev} className="p-2">
            <img src={chevironLeft} alt="이전 날짜" />
          </Button>

          <button
            onClick={clickModal}
            className="inline-flex gap-4 items-center justify-center [&>*]:pointer-events-none disabled:opacity-30 bg-white border h-10 rounded p-0 text-base font-medium border-none"
          >
            {currentDate.year}.{String(currentDate.month + 1).padStart(2, "0")}.
            {String(currentDate.day).padStart(2, "0")}
          </button>

          <Button onClick={handleNext} className="p-2">
            <img src={chevironRight} alt="다음 날짜" />
          </Button>
        </div> */}

        {/* 예약 타입 탭 */}
        {!isLoading && reservTypes.length > 0 && (
          <div className="grid grid-cols-1 pb-2 pt-2">
            <div className="flex overflow-x-auto gap-2 whitespace-nowrap">
              {reservTypes.map((reservType) => (
                <button
                  key={reservType.key}
                  onClick={() => handleReservTypeClick(reservType)}
                  className={`
                      px-4 py-1 rounded-full border text-sm font-semibold h-10
                      bg-white
                      ${
                        selectedReservType?.key === reservType.key
                          ? "border-orange-400 text-orange-400"
                          : "border-transparent text-gray-700 border-[#CCCCCC]"
                      }
                    `}
                >
                  {reservType.value}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col flex-auto bg-[#F5F5F5]">
        <div className="flex justify-between items-center px-4 py-2">
          <span className="text-sm text-gray-700">
            총 <span className="font-semibold text-gray-900">{reserveList?.data?.length ?? 0}</span>건
          </span>
        </div>
        {isReserveListLoading ? (
          <div className="flex flex-auto justify-center items-center">
            <div className="text-gray-500">로딩 중...</div>
          </div>
        ) : reserveList?.data && reserveList.data.length > 0 ? (
          <ReservationTimeline
            items={reserveList.data}
            getDateString={(reservation) => reservation.date}
            getKey={(reservation) => reservation.reservationSeq}
            renderItem={(reservation) => (
              <StudentCard
                student={{
                  id: reservation.reservationSeq.toString(),
                  name: reservation.petName,
                  weight: reservation.petWeight,
                  status: reservation.reservation || "예약",
                  img: reservation.thumbnailUrl || defaultPet,
                  cdAttendStatus: reservation.cdReservStatus,
                  petDrop: false, // API에서 제공되지 않는 정보
                  ticketName: reservation.ticketName,
                  timeLines: buildTimeLines(reservation),
                }}
                attendanceType={reservation.reservation || ""}
                onClick={() => {
                  history.push(
                    `/business/layout/revservation?reservationSeq=${reservation.reservationSeq}&source=confirm`,
                  );
                }}
                isSelected={false}
              />
            )}
          />
        ) : isReserveListError ? (
          <div className="flex flex-auto flex-col gap-2 justify-center items-center">
            <div className="text-gray-500">
              예약 목록을 불러오지 못했습니다.
            </div>
            <div className="text-sm text-gray-400">
              네트워크 상태를 확인한 뒤 다시 시도해주세요.
            </div>
          </div>
        ) : (
          <div className="flex flex-auto justify-center items-center">
            <div className="text-gray-500">확정된 예약이 없습니다.</div>
          </div>
        )}
      </div>
    </>
  );
};

interface Student {
  id: string;
  name: string;
  weight: string;
  status: string;
  img: string | null;
  petDrop: boolean;
  cdAttendStatus: string;
  reserveDate?: string;
  ticketName?: string | null;
  timeLines?: string[];
}

const CheckIcon = ({
  color,
  iconColor,
  size = "big",
}: {
  color: string;
  iconColor: string;
  size?: string;
}) => {
  if (size === "small") {
    return (
      <div
        className={`flex justify-center items-center w-4 h-4 rounded-full border-2 ${color} pb-[2px]`}
      >
        <svg
          className={`w-3 h-3 pt-[1px] ${iconColor}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
    );
  } else {
    return (
      <div
        className={`flex justify-center items-center w-12 h-12 rounded-full border-2 ${color}`}
      >
        <svg
          className={`w-6 h-6 ${iconColor}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
    );
  }
};

const StudentCard = ({
  student,
  attendanceType,
  onClick,
  isSelected,
}: {
  student: Student;
  attendanceType: string;
  onClick: (student: Student) => void;
  isSelected: boolean;
}) => {
  const borderColor =
    attendanceType === "등원" ? "border-orange-400" : "border-[#7D6DFF]";
  const checkIconColor =
    attendanceType === "등원" ? "text-orange-400" : "text-[#7D6DFF]";
  const truckIconColor = attendanceType === "등원" ? "#ED8432" : "#7D6DFF";
  const handleClick = () => {
    onClick(student);
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -20, scale: 0.95 }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
      }}
      onClick={handleClick}
      className={`bg-white rounded-xl p-3 flex items-end gap-4 mb-2 border-[1px] ${isSelected ? borderColor : "border-[#E0E0E0]"}`}
    >
      {isSelected ? (
        <div className="flex justify-center items-center">
          <CheckIcon color={borderColor} iconColor={checkIconColor} />
        </div>
      ) : (
        <img
          src={student.img || defaultPet}
          alt={student.name}
          className="object-cover flex-shrink-0 w-12 h-12 rounded-full"
        />
      )}
      <div className="flex flex-col w-full gap-2">
        <div className="flex gap-2 justify-between items-baseline">
          <div className="flex gap-2 items-baseline min-w-0">
            <p className="font-bold text-gray-800 truncate">{student.name}</p>
            <p className="text-sm text-gray-500 shrink-0">{student.weight}</p>
            {(student.cdAttendStatus == "ATTEND_STATUS_ATTENDED" &&
              attendanceType == "등원") ||
            (student.cdAttendStatus == "ATTEND_STATUS_DISMISSED" &&
              attendanceType == "하원") ? (
              <div className="flex justify-center items-end shrink-0">
                <CheckIcon
                  color={borderColor}
                  iconColor={checkIconColor}
                  size="small"
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          {student.timeLines && student.timeLines.length > 0 && (
            <div className="flex shrink-0 flex-col items-end text-xs leading-tight text-gray-500">
              {student.timeLines.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </div>
          )}
        </div>
        <div className="flex gap-2 justify-between">
          <div className="flex min-w-0 items-baseline gap-2">
            <p className="shrink-0 text-sm text-gray-600">{student.status}</p>
            {/* 예약일은 타임라인 날짜 헤더가 표시하므로 사용 이용권을 표시 */}
            {student.ticketName && (
              <p className="truncate text-xs text-gray-400">
                {student.ticketName}
              </p>
            )}
          </div>
          {student.petDrop && <TruckIcon color={truckIconColor} />}
        </div>
      </div>
    </motion.div>
  );
};

export default CalendarConfirm;
